import { Card, Form, Input, Typography } from 'antd';
import { CreateLayout } from 'components/layout/layout/CreateLayout';
import { IRole } from 'interfaces/roles';
import { PageHeader } from 'components/professor_area/PageHeader';
import { Permissions } from './components/permissions';
import { SettingOutlined } from '@ant-design/icons';
import { useForm } from '@refinedev/antd';

export const RoleCreate = () => {
  const { formProps, saveButtonProps, form } = useForm<IRole>();

  return (
    <CreateLayout
      saveButtonProps={saveButtonProps}
      title="Criar regra de acesso"
    >
      <PageHeader title="Criar regra de acesso" icon={SettingOutlined} />
      <Card>
        <Form {...formProps} layout="vertical">
          <Typography.Title level={4} style={{ marginBottom: 20 }}>
            Informações gerais
          </Typography.Title>

          <Form.Item
            label="Nome do perfil"
            name="name"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item label="Permissões" name="permissions" hidden>
            <Input value={form.getFieldValue('permissions')} hidden />
          </Form.Item>

          <Typography.Title level={4} style={{ margin: '30px 0 20px' }}>
            Regras de acesso
          </Typography.Title>

          <Permissions
            permissions={[]}
            onChange={data => {
              form.setFieldValue('permissions', data);
            }}
          />
        </Form>
      </Card>
    </CreateLayout>
  );
};
